import React from "react";
import { Chip, withStyles } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

const styles = (theme) => ({
  chipRoot: {
    fontSize: 11,
    margin: "2px 4px 2px 0px",
    height: "max-content",
    padding: "6px 0px",
    borderRadius: 5,
    backgroundColor: theme.lightPrimaryColor,
    color: theme.selectedRadioLabelText,
    "&:focus": {
      backgroundColor: theme.lightPrimaryColor,
    },
    maxWidth: "100%",
  },
  chipDeleteIcon: {
    cursor: "pointer",
    color: theme.palette.primary.main,
    zIndex: 2,
  },
  chipLabel: {
    letterSpacing: 0.4,
    whiteSpace: "normal",
  },
});

const StyledChip = ({ label, remove, classes }) => {
  return (
    <Chip
      label={label}
      classes={{
        root: classes.chipRoot,
        icon: classes.chipDeleteIcon,
        label: classes.chipLabel,
      }}
      clickable={false}
      color="primary"
      icon={remove ? <Clear onClick={remove} /> : null}
    />
  );
};

export default withStyles(styles)(StyledChip);
